import localforage from "localforage";
import {stringify} from "querystring";

class History
{
    static initialisation() {
        return new Promise((resolve, reject) => {
            localforage.setItem('listHistory', []).then(() => {
                resolve();
            }).catch((err) => {
                reject(err);
            })
        })
    }

    static getHistory(type) {
        return new Promise(async (resolve) => {

            let historys = await localforage.getItem('listHistory');

            if(historys[type] !== undefined) {
                resolve(historys[type]);
            }

            if(typeof type === "undefined") {
                resolve(null);
            }

            if(typeof history === 'undefined') {
                history = {
                    text: "",
                    options: {}
                }

                this.setHistory(type, history);
            }

            resolve(history);
        })
    }

    static setHistory(type, data) {
        return new Promise(async (resolve) => {

            let historys = await localforage.getItem('listHistory');
            if(historys === null) {
                historys = [];
            }

            let history = null

            if(historys[type] !== undefined) {
                history = historys[type];
            }

            if (history != null) {
                history.text = data.text;
                history.options = data.options;
            } else {
                historys[type] = data;
            }

            localforage.setItem('listHistory', historys).then(() => {
                resolve();
            })

        })
    }

    static clearHistory(key, value = null) {
        return new Promise(async (resolve) => {

            let historys = await localforage.getItem('listHistory');
            if(historys === null) {
                historys = [];
            }

            if(typeof key !== "undefined") {
                if(historys[key] !== undefined) {
                    if(value !== null) {
                        if(historys[key][value] !== undefined) {
                            delete historys[key][value];
                        }
                    }else{
                        delete historys[key];
                    }
                }
            } else {
                historys = [];
            }

            localforage.setItem('listHistory', historys).then(() => {
                resolve();
            })

        })
    }



} export default History;



// WEBPACK FOOTER //
// ./src/js/core/History.js